// export * from './main.component';
// import * from './desktop/';
// import * from './mobile/';

export * from './main.component';

export * from './main.routes';

export * from './main.module';